import { MatchData } from "@/interfaces/liveGamesType";

export const fakeMatchData: MatchData = {
  match_id: "",
  country_id: "64",
  country_name: "Japan",
  league_id: "209",
  league_name: "J1 League",
  match_date: "2025-05-03",
  match_status: "2",
  match_time: "1:00",
  match_hometeam_id: "5046",
  match_hometeam_name: "Fish Ball",
  match_hometeam_score: "0",
  match_awayteam_name: "Cat",
  match_awayteam_id: "5048",
  match_awayteam_score: "0",
  match_hometeam_halftime_score: "0",
  match_awayteam_halftime_score: "0",
  match_hometeam_extra_score: "",
  match_awayteam_extra_score: "",
  match_hometeam_penalty_score: "",
  match_awayteam_penalty_score: "",
  match_hometeam_ft_score: "",
  match_awayteam_ft_score: "",
  match_hometeam_system: "3-4-2-1",
  match_awayteam_system: "3-4-2-1",
  match_live: "1",
  match_round: "14",
  match_stadium: "",
  match_referee: "Koki Nagamine, Japan",
  team_home_badge:
    "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
  team_away_badge:
    "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
  league_logo:
    "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
  country_logo:
    "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
  league_year: "2025",
  fk_stage_key: "1179",
  stage_name: "Current",
  goalscorer: [],
  substitutions: {
    home: [],
    away: [],
  },
  cards: [],
  lineup: {
    home: {
      starting_lineups: [
        {
          lineup_player: "Keisuke Osako",
          lineup_number: "1",
          lineup_position: "1",
          player_key: "783882154",
        },
        {
          lineup_player: "Tsukasa Shiotani",
          lineup_number: "33",
          lineup_position: "2",
          player_key: "3524718349",
        },
        {
          lineup_player: "Hayato Araki",
          lineup_number: "4",
          lineup_position: "3",
          player_key: "1242632877",
        },
        {
          lineup_player: "Sho Sasaki",
          lineup_number: "19",
          lineup_position: "4",
          player_key: "4243445056",
        },
        {
          lineup_player: "Sota Nakamura",
          lineup_number: "39",
          lineup_position: "5",
          player_key: "9672758",
        },
        {
          lineup_player: "Hayao Kawabe",
          lineup_number: "6",
          lineup_position: "6",
          player_key: "1854690037",
        },
        {
          lineup_player: "Satoshi Tanaka",
          lineup_number: "14",
          lineup_position: "7",
          player_key: "2571581559",
        },
        {
          lineup_player: "Shunki Higashi",
          lineup_number: "24",
          lineup_position: "8",
          player_key: "3205061289",
        },
        {
          lineup_player: "Naoki Maeda",
          lineup_number: "41",
          lineup_position: "9",
          player_key: "2571410738",
        },
        {
          lineup_player: "Mutsuki Kato",
          lineup_number: "51",
          lineup_position: "10",
          player_key: "1709154931",
        },
        {
          lineup_player: "Ryo Germain",
          lineup_number: "9",
          lineup_position: "11",
          player_key: "1347258472",
        },
      ],
      substitutes: [
        {
          lineup_player: "Jeong Min-ki",
          lineup_number: "26",
          lineup_position: "0",
          player_key: "1015459657",
        },
        {
          lineup_player: "Shuto Nakano",
          lineup_number: "15",
          lineup_position: "0",
          player_key: "1750120372",
        },
        {
          lineup_player: "Taichi Yamasaki",
          lineup_number: "3",
          lineup_position: "0",
          player_key: "1862436581",
        },
        {
          lineup_player: "Sota Koshimichi",
          lineup_number: "32",
          lineup_position: "0",
          player_key: "1040167706",
        },
        {
          lineup_player: "Taishi Semba",
          lineup_number: "44",
          lineup_position: "0",
          player_key: "1070989559",
        },
        {
          lineup_player: "Hiroya Matsumoto",
          lineup_number: "5",
          lineup_position: "0",
          player_key: "774075590",
        },
        {
          lineup_player: "Shion Inoue",
          lineup_number: "20",
          lineup_position: "0",
          player_key: "3910840919",
        },
        {
          lineup_player: "Daiki Suga",
          lineup_number: "18",
          lineup_position: "0",
          player_key: "3833534690",
        },
        {
          lineup_player: "Aren Inoue",
          lineup_number: "36",
          lineup_position: "0",
          player_key: "3215162166",
        },
      ],
      coach: [
        {
          lineup_player: "M. Skibbe",
          lineup_number: "",
          lineup_position: "",
          player_key: "776686729",
        },
      ],
      missing_players: [],
    },
    away: {
      starting_lineups: [
        {
          lineup_player: "Takumi Nagaishi",
          lineup_number: "1",
          lineup_position: "1",
          player_key: "1363320462",
        },
        {
          lineup_player: "Masaya Tashiro",
          lineup_number: "37",
          lineup_position: "2",
          player_key: "2981881254",
        },
        {
          lineup_player: "Tomoya Ando",
          lineup_number: "20",
          lineup_position: "3",
          player_key: "3692125797",
        },
        {
          lineup_player: "Takumi Kamijima",
          lineup_number: "5",
          lineup_position: "4",
          player_key: "3844391100",
        },
        {
          lineup_player: "Yu Hashimoto",
          lineup_number: "47",
          lineup_position: "5",
          player_key: "2258901380",
        },
        {
          lineup_player: "Daiki Matsuoka",
          lineup_number: "88",
          lineup_position: "6",
          player_key: "704200843",
        },
        {
          lineup_player: "Tomoya Miki",
          lineup_number: "11",
          lineup_position: "7",
          player_key: "3210522252",
        },
        {
          lineup_player: "Yuto Iwasaki",
          lineup_number: "18",
          lineup_position: "8",
          player_key: "3323276553",
        },
        {
          lineup_player: "Kazuya Konno",
          lineup_number: "8",
          lineup_position: "9",
          player_key: "980033816",
        },
        {
          lineup_player: "Takeshi Kanamori",
          lineup_number: "7",
          lineup_position: "10",
          player_key: "1029141098",
        },
        {
          lineup_player: "Wellington",
          lineup_number: "17",
          lineup_position: "11",
          player_key: "3861324241",
        },
      ],
      substitutes: [
        {
          lineup_player: "Masaaki Murakami",
          lineup_number: "31",
          lineup_position: "0",
          player_key: "3925674618",
        },
        {
          lineup_player: "Kim Moon-Hyeon",
          lineup_number: "19",
          lineup_position: "0",
          player_key: "3804763899",
        },
        {
          lineup_player: "Masato Shigemi",
          lineup_number: "6",
          lineup_position: "0",
          player_key: "4038304902",
        },
        {
          lineup_player: "Yota Maejima",
          lineup_number: "29",
          lineup_position: "0",
          player_key: "1167033630",
        },
        {
          lineup_player: "Hiroki Akino",
          lineup_number: "15",
          lineup_position: "0",
          player_key: "470148511",
        },
        {
          lineup_player: "Shintaro Nago",
          lineup_number: "14",
          lineup_position: "0",
          player_key: "3119061956",
        },
        {
          lineup_player: "Sonosuke Sato",
          lineup_number: "50",
          lineup_position: "0",
          player_key: "4003952079",
        },
        {
          lineup_player: "Ichika Maeda",
          lineup_number: "49",
          lineup_position: "0",
          player_key: "3256171333",
        },
        {
          lineup_player: "Shahab Zahedi",
          lineup_number: "9",
          lineup_position: "0",
          player_key: "768781170",
        },
      ],
      coach: [
        {
          lineup_player: "Kim Myung Hwi",
          lineup_number: "",
          lineup_position: "",
          player_key: "1509231360",
        },
      ],
      missing_players: [],
    },
  },
  statistics: [
    {
      type: "Corners",
      home: "0",
      away: "0",
    },
    {
      type: "Throw In",
      home: "0",
      away: "0",
    },
    {
      type: "Free Kick",
      home: "0",
      away: "0",
    },
    {
      type: "Goal Kick",
      home: "0",
      away: "0",
    },
    {
      type: "Penalty",
      home: "0",
      away: "0",
    },
    {
      type: "Substitution",
      home: "0",
      away: "0",
    },
    {
      type: "Attacks",
      home: "4",
      away: "2",
    },
    {
      type: "Dangerous Attacks",
      home: "1",
      away: "0",
    },
    {
      type: "On Target",
      home: "1",
      away: "0",
    },
    {
      type: "Off Target",
      home: "0",
      away: "0",
    },
  ],
  statistics_1half: [],
};

export const fakePredictionsData = {
  match_id: "504973",
  country_id: "64",
  country_name: "Japan",
  league_id: "209",
  league_name: "J1 League",
  match_date: "2025-05-03",
  match_status: "36",
  match_time: "1:00",
  match_hometeam_id: "5046",
  match_hometeam_name: "Time 1",
  match_hometeam_score: "0",
  match_awayteam_name: "Time 2",
  match_awayteam_id: "5048",
  match_awayteam_score: "0",
  match_hometeam_halftime_score: "0",
  match_awayteam_halftime_score: "0",
  match_hometeam_extra_score: "0",
  match_awayteam_extra_score: "0",
  match_hometeam_penalty_score: "",
  match_awayteam_penalty_score: "",
  match_hometeam_system: "3-4-2-1",
  match_awayteam_system: "3-4-2-1",
  match_live: "1",
  prob_HW: "69.00",
  prob_D: "24.00",
  prob_AW: "7.00",
  prob_HW_D: "72.00",
  prob_AW_D: "66.00",
  prob_HW_AW: "62.00",
  prob_O: "17.00",
  prob_U: "83.00",
  prob_O_1: "42.00",
  prob_U_1: "58.00",
  prob_O_3: "6.00",
  prob_U_3: "94.00",
  prob_bts: "26.00",
  prob_ots: "74.00",
  prob_ah_h_45: "100.00",
  prob_ah_a_45: "0.00",
  prob_ah_h_35: "100.00",
  prob_ah_a_35: "0.00",
  prob_ah_h_25: "98.00",
  prob_ah_a_25: "2.00",
  prob_ah_h_15: "92.00",
  prob_ah_a_15: "8.00",
  prob_ah_h_05: "72.00",
  prob_ah_a_05: "28.00",
  "prob_ah_h_-05": "34.00",
  "prob_ah_a_-05": "66.00",
  "prob_ah_h_-15": "11.00",
  "prob_ah_a_-15": "89.00",
  "prob_ah_h_-25": "2.00",
  "prob_ah_a_-25": "98.00",
  "prob_ah_h_-35": "0.00",
  "prob_ah_a_-35": "100.00",
  "prob_ah_h_-45": "0.00",
  "prob_ah_a_-45": "100.00",
  team_away_badge:
    "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
  team_home_badge:
    "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
};

export const fakeLiveOddsData = {
  match_id: "504973",
  country_name: "Japan",
  league_name: "J1 League",
  match_date: "2025-05-03",
  match_time: "06:00",
  match_status: "Half Time",
  match_hometeam_name: "Sanfrecce Hiroshima",
  match_hometeam_score: "0",
  match_awayteam_name: "Avispa Fukuoka",
  match_awayteam_score: "0",
  live_odds: [
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Over",
      value: "6",
      handicap: "12",
      upd: "2025-05-03 06:53:46",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Exactly",
      value: "7.5",
      handicap: "12",
      upd: "2025-05-03 06:50:22",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Under",
      value: "1.25",
      handicap: "12",
      upd: "2025-05-03 06:59:47",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Over",
      value: "2.375",
      handicap: "10",
      upd: "2025-05-03 06:54:21",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Exactly",
      value: "5.5",
      handicap: "10",
      upd: "2025-05-03 06:43:22",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Under",
      value: "2",
      handicap: "10",
      upd: "2025-05-03 06:59:47",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Over",
      value: "3.75",
      handicap: "11",
      upd: "2025-05-03 06:59:47",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Exactly",
      value: "6",
      handicap: "11",
      upd: "2025-05-03 06:47:47",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Under",
      value: "1.533",
      handicap: "11",
      upd: "2025-05-03 06:54:21",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Over",
      value: "1.727",
      handicap: "9",
      upd: "2025-05-03 06:59:47",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Exactly",
      value: "5",
      handicap: "9",
      upd: "2025-05-03 06:47:22",
    },
    {
      odd_name: "Match Corners",
      suspended: "No",
      type: "Under",
      value: "3.4",
      handicap: "9",
      upd: "2025-05-03 06:53:46",
    },
    {
      odd_name: "Asian Handicap",
      suspended: "No",
      type: "Home",
      value: "2.675",
      handicap: "-0.75",
      upd: "2025-05-03 06:48:22",
    },
    {
      odd_name: "Asian Handicap",
      suspended: "No",
      type: "Away",
      value: "1.45",
      handicap: "0.75",
      upd: "2025-05-03 06:48:22",
    },
  ],
  live_comments: [
    {
      time: "01:51",
      text: "Avispa Fukuoka in possession",
      state: "T Nagaishi",
    },
    {
      time: "02:14",
      text: "Sanfrecce Hiroshima in possession",
      state: "H Kawabe",
    },
    {
      time: "04:45",
      text: "Avispa Fukuoka goal kick",
      state: "",
    },
    {
      time: "05:15",
      text: "Avispa Fukuoka in possession",
      state: "D Matsuoka",
    },
    {
      time: "06:02",
      text: "Sanfrecce Hiroshima in possession",
      state: "H Kawabe",
    },
    {
      time: "06:51",
      text: "Sanfrecce Hiroshima attack",
      state: "H Kawabe",
    },
    {
      time: "07:15",
      text: "Avispa Fukuoka in possession",
      state: "T Miki",
    },
    {
      time: "07:50",
      text: "Sanfrecce Hiroshima in possession",
      state: "H Araki",
    },
    {
      time: "08:16",
      text: "Sanfrecce Hiroshima dangerous attack",
      state: "M Kato",
    },
    {
      time: "08:49",
      text: "Avispa Fukuoka in possession",
      state: "Y Iwasaki",
    },
    {
      time: "09:14",
      text: "Avispa Fukuoka goal kick",
      state: "",
    },
    {
      time: "09:51",
      text: "Sanfrecce Hiroshima dangerous attack",
      state: "M Kato",
    },
    {
      time: "10:16",
      text: "Avispa Fukuoka in possession",
      state: "T Ando",
    },
    {
      time: "11:13",
      text: "Sanfrecce Hiroshima in possession",
      state: "S Sasaki",
    },
    {
      time: "12:15",
      text: "Avispa Fukuoka in possession",
      state: "W de Sousa",
    },
    {
      time: "13:50",
      text: "Sanfrecce Hiroshima shot off goal",
      state: "H Araki,",
    },
    {
      time: "14:13",
      text: "Avispa Fukuoka in possession",
      state: "T Nagaishi",
    },
    {
      time: "14:45",
      text: "Sanfrecce Hiroshima shot on goal",
      state: "M Kato,",
    },
    {
      time: "15:51",
      text: "Sanfrecce Hiroshima attack",
      state: "T Shiotani",
    },
    {
      time: "16:46",
      text: "Sanfrecce Hiroshima shot off goal",
      state: "S Nakamura,",
    },
    {
      time: "17:08",
      text: "Avispa Fukuoka attack",
      state: "W de Sousa",
    },
    {
      time: "17:47",
      text: "Sanfrecce Hiroshima in possession",
      state: "S Tanaka",
    },
    {
      time: "18:16",
      text: "Sanfrecce Hiroshima attack",
      state: "R Germain",
    },
    {
      time: "18:42",
      text: "Avispa Fukuoka attack",
      state: "K Konno",
    },
    {
      time: "19:13",
      text: "Avispa Fukuoka in possession",
      state: "M Tashiro",
    },
    {
      time: "19:52",
      text: "Sanfrecce Hiroshima in possession",
      state: "S Tanaka",
    },
    {
      time: "20:49",
      text: "Sanfrecce Hiroshima attack",
      state: "N Maeda",
    },
    {
      time: "21:11",
      text: "Sanfrecce Hiroshima dangerous attack",
      state: "R Germain",
    },
    {
      time: "21:49",
      text: "Sanfrecce Hiroshima attack",
      state: "N Maeda",
    },
    {
      time: "22:15",
      text: "Sanfrecce Hiroshima dangerous attack",
      state: "M Kato",
    },
    {
      time: "23:17",
      text: "Sanfrecce Hiroshima yellow card",
      state: "",
    },
    {
      time: "23:51",
      text: "Sanfrecce Hiroshima in possession",
      state: "K Osako",
    },
    {
      time: "24:51",
      text: "Avispa Fukuoka shot off gsoal",
      state: "T Kamijima,",
    },
    {
      time: "25:15",
      text: "Sanfrecce Hiroshima in possession",
      state: "K Osako",
    },
    {
      time: "26:15",
      text: "Sanfrecce Hiroshima free kick",
      state: "",
    },
    {
      time: "26:42",
      text: "Avispa Fukuoka in possession",
      state: "M Tashiro",
    },
    {
      time: "30:15",
      text: "Sanfrecce Hiroshima shot on goal",
      state: "R Germain,",
    },
    {
      time: "30:51",
      text: "Sanfrecce Hiroshima in possession",
      state: "S Higashi",
    },
    {
      time: "34:14",
      text: "Avispa Fukuoka in possession",
      state: "T Ando",
    },
    {
      time: "34:47",
      text: "Avispa Fukuoka attack",
      state: "T Miki",
    },
    {
      time: "40:52",
      text: "Sanfrecce Hiroshima attack",
      state: "T Shiotani",
    },
    {
      time: "41:13",
      text: "Avispa Fukuoka in possession",
      state: "Y Iwasaki",
    },
    {
      time: "42:15",
      text: "Avispa Fukuoka shot on gsoal",
      state: "T Kanamori,",
    },
    {
      time: "42:51",
      text: "Sanfrecce Hiroshima in possession",
      state: "S Sasaki",
    },
    {
      time: "43:15",
      text: "Avispa Fukuoka in possession",
      state: "T Kamijima",
    },
    {
      time: "43:48",
      text: "Sanfrecce Hiroshima dangerous attack",
      state: "N Maeda",
    },
    {
      time: "44:14",
      text: "Avispa Fukuoka attack",
      state: "W de Sousa",
    },
    {
      time: "45:00",
      text: "Half time",
      state: "",
    },
    {
      time: "46:48",
      text: "Avispa Fukuoka goal kick",
      state: "",
    },
    {
      time: "47:06",
      text: "Sanfrecce Hiroshima attack",
      state: "R Germain",
    },
    {
      time: "47:46",
      text: "Avispa Fukuoka in possession",
      state: "T Kamijima",
    },
  ],
};

export const fakeH2HData = {
  firstTeam_VS_secondTeam: [
    {
      match_id: "339905",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2024-07-14",
      match_status: "Finished",
      match_time: "11:30",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "339754",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2024-04-13",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "167985",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2023-12-03",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "0",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "167782",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2023-05-07",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "3",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "88762",
      country_id: "64",
      country_name: "Japan",
      league_id: "210",
      league_name: "J-League Cup",
      match_date: "2022-09-25",
      match_status: "Finished",
      match_time: "10:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "0",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/210_j-league-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "88761",
      country_id: "64",
      country_name: "Japan",
      league_id: "210",
      league_name: "J-League Cup",
      match_date: "2022-09-21",
      match_status: "Finished",
      match_time: "12:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "2",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "3",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/210_j-league-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "88981",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2022-06-25",
      match_status: "Finished",
      match_time: "11:30",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "3",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "88894",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2022-04-10",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
  ],
  firstTeam_lastResults: [
    {
      match_id: "504964",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-29",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "0",
      match_awayteam_id: "5075",
      match_awayteam_name: "Albirex Niigata",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5075_albirex-niigata.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504948",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-25",
      match_status: "Finished",
      match_time: "12:30",
      match_hometeam_id: "5051",
      match_hometeam_name: "Urawa Reds",
      match_hometeam_score: "1",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5051_urawa-reds.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504943",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-20",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "415",
      match_hometeam_name: "Nagoya Grampus",
      match_hometeam_score: "2",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/415_nagoya-grampus.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504935",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-12",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "0",
      match_awayteam_id: "5084",
      match_awayteam_name: "Fagiano Okayama",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5084_fagiano-okayama.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504925",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-06",
      match_status: "Finished",
      match_time: "08:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "2",
      match_awayteam_id: "5045",
      match_awayteam_name: "Cerezo Osaka",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5045_cerezo-osaka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504916",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-02",
      match_status: "Finished",
      match_time: "12:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5053",
      match_awayteam_name: "Kashima Antlers",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5053_kashima-antlers.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504904",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-03-29",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5078",
      match_hometeam_name: "Kyoto Sanga",
      match_hometeam_score: "1",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5078_kyoto-sanga.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504895",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-03-16",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5055",
      match_awayteam_name: "Kashiwa Reysol",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5055_kashiwa-reysol.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "535374",
      country_id: "2",
      country_name: "intl",
      league_id: "11",
      league_name: "AFC Champions League Two",
      match_date: "2025-03-12",
      match_status: "Finished",
      match_time: "13:00",
      match_hometeam_id: "468",
      match_hometeam_name: "Lion City Sailors",
      match_hometeam_score: "1",
      match_awayteam_id: "5046",
      match_awayteam_name: "Time casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/468_lion-city-sailors.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/11_afc-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/2_intl.png",
    },
    {
      match_id: "535373",
      country_id: "2",
      country_name: "intl",
      league_id: "11",
      league_name: "AFC Champions League Two",
      match_date: "2025-03-05",
      match_status: "Finished",
      match_time: "11:00",
      match_hometeam_id: "5046",
      match_hometeam_name: "Time casa Placeholder",
      match_hometeam_score: "0",
      match_awayteam_id: "468",
      match_awayteam_name: "Lion City Sailors",
      match_awayteam_score: "3",
      match_hometeam_halftime_score: "2",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5046_sanfrecce-hiroshima.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/468_lion-city-sailors.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/11_afc-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/2_intl.png",
    },
  ],
  secondTeam_lastResults: [
    {
      match_id: "504959",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-29",
      match_status: "Finished",
      match_time: "08:00",
      match_hometeam_id: "5054",
      match_hometeam_name: "Shonan Bellmare",
      match_hometeam_score: "0",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5054_shonan-bellmare.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504954",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-25",
      match_status: "Finished",
      match_time: "12:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5084",
      match_awayteam_name: "Fagiano Okayama",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5084_fagiano-okayama.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504942",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-20",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5047",
      match_hometeam_name: "Shimizu S-Pulse",
      match_hometeam_score: "3",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "3",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5047_shimizu-s-pulse.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "548947",
      country_id: "64",
      country_name: "Japan",
      league_id: "210",
      league_name: "J-League Cup",
      match_date: "2025-04-16",
      match_status: "Finished",
      match_time: "12:00",
      match_hometeam_id: "5093",
      match_hometeam_name: "Tochigi",
      match_hometeam_score: "1",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "2",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge: "https://apiv3.apifootball.com/badges/5093_tochigi.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/210_j-league-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504936",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-12",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "2",
      match_awayteam_id: "387",
      match_awayteam_name: "Yokohama F. Marinos",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/387_yokohama-f.-marinos.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504926",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-06",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "5051",
      match_awayteam_name: "Urawa Reds",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5051_urawa-reds.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504911",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-04-02",
      match_status: "Finished",
      match_time: "12:00",
      match_hometeam_id: "5075",
      match_hometeam_name: "Albirex Niigata",
      match_hometeam_score: "0",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "1",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5075_albirex-niigata.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504906",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-03-29",
      match_status: "Finished",
      match_time: "07:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "2",
      match_awayteam_id: "5085",
      match_awayteam_name: "Machida Zelvia",
      match_awayteam_score: "2",
      match_hometeam_halftime_score: "1",
      match_awayteam_halftime_score: "1",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5085_machida-zelvia.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "516980",
      country_id: "64",
      country_name: "Japan",
      league_id: "210",
      league_name: "J-League Cup",
      match_date: "2025-03-20",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5076",
      match_hometeam_name: "Ryūkyū",
      match_hometeam_score: "0",
      match_awayteam_id: "5048",
      match_awayteam_name: "Time Casa Placeholder",
      match_awayteam_score: "2",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge: "https://apiv3.apifootball.com/badges/5076_ryky.jpg",
      team_away_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/210_j-league-cup.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
    {
      match_id: "504896",
      country_id: "64",
      country_name: "Japan",
      league_id: "209",
      league_name: "J1 League",
      match_date: "2025-03-15",
      match_status: "Finished",
      match_time: "06:00",
      match_hometeam_id: "5048",
      match_hometeam_name: "Time Casa Placeholder",
      match_hometeam_score: "1",
      match_awayteam_id: "380",
      match_awayteam_name: "Tokyo",
      match_awayteam_score: "0",
      match_hometeam_halftime_score: "0",
      match_awayteam_halftime_score: "0",
      match_live: "0",
      team_home_badge:
        "https://apiv3.apifootball.com/badges/5048_avispa-fukuoka.jpg",
      team_away_badge: "https://apiv3.apifootball.com/badges/380_tokyo.jpg",
      league_logo:
        "https://apiv3.apifootball.com/badges/logo_leagues/209_j1-league.png",
      country_logo:
        "https://apiv3.apifootball.com/badges/logo_country/64_japan.png",
    },
  ],
};
